<template>
    <div class="mwap_index">
        <div class="mwap_index_header">
            <div class="mwap_index_header_contiainer">
                <img :src="require('assets/img/mwap/bg-1.png')" alt="">
            </div>
            <div class="mwap_rule">
                <div class="mvbutton mwap_rule_btn" @click="showrule=true">查看规则</div>
            </div>
        </div>
        <div class="mwap_index_body">
            <PushUpsList v-if="pushUpsList.length" :pushUpsList="pushUpsList" v-on:goDetail="goDetail"></PushUpsList>
            <van-skeleton title  :row="2" :animate="false" v-else/>
        </div>
        <van-overlay :show="showrule"  >
            <div class="wrapper">
                <div class="block">
                    <div class="block_header">
                        <div>规则说明</div>
                        <img :src="require('assets/img/mwap/colse.png')" alt="" @click="showrule = false">
                    </div>
                    <div class="block_body">{{rule}}</div>                    
                </div>                
            </div>
        </van-overlay>
    </div>
</template>
<script>
    import './index.less'
    import PushUpsList from '@/views/Mwap/PushUpsList'
    import { Overlay } from 'vant';  
    export default {
        data(){
          return {
              pushUpsList:[],
              cgid:'',
              caid:'',
              id:'',
              showrule:false,
              rule:''
          }
        },
        components:{
            vanOverlay:Overlay,
            PushUpsList
        },
        methods:{
            getPushUpsList(){
                this.$api.mwap.pushUpsList().then((res)=>{
                    if(res.status*1===200){
                        this.pushUpsList  =   res.data.list
                        this.caid = res.data.caid
                        this.rule = res.data.rule
                    }

                })
            },
            goDetail(val){
                this.cgid = val
                this.$router.push({name:'mwapdetail',params: {caid: this.caid,cgid: this.cgid,id: this.id}})
            }
        },
        mounted(){
            this.id = this.$route.params.id
            this.$nextTick(()=>{
                this.getPushUpsList();
            })
        }
    }
</script>